import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  templateUrl: './oauth-callback.component.html',
})
export class OauthCallbackComponent implements OnInit {

  constructor(
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {

    const token = this.router.url.split('=')[1];

    if (token) {

      window.opener.postMessage(token, environment.webOrigin);
      window.close();

    } else {
      console.error('No oauth token found in the URL');
    }
  }

}
